import { useEffect } from 'react';
import { HotelRecord, Timeframe } from '../../../../common/types';
import {
  convertToKeenFriendlyHotelTimeframe,
  useKeenQuery,
} from '../../../../utils/keen';

const useTotalRevenueByCategoryData = ({
  hotel,
  timeframe,
}: {
  hotel: HotelRecord;
  timeframe: Timeframe;
}) => {
  const [
    {
      data: totalRevenueByCategory = [],
      loading: isTotalRevenueByCategoryLoading,
    },
    queryTotalRevenueByCategory,
  ] = useKeenQuery<{ categoryId: string; result: number }[]>();

  useEffect(() => {
    queryTotalRevenueByCategory({
      analysisType: 'sum',
      eventCollection: 'orders',
      targetProperty: 'total',
      groupBy: 'category_id',
      filters: [
        {
          propertyName: 'hotel_id',
          operator: 'eq',
          propertyValue: hotel.id,
        },
        {
          propertyName: 'test_order',
          operator: 'eq',
          propertyValue: false,
        },
      ],
      timeframe:
        typeof timeframe === 'string'
          ? timeframe
          : convertToKeenFriendlyHotelTimeframe(timeframe, hotel.tzInfoId),
      timezone: hotel.tzInfoId,
    });
  }, [hotel.id, queryTotalRevenueByCategory, timeframe, hotel.tzInfoId]);

  return {
    data: totalRevenueByCategory,
    loading: isTotalRevenueByCategoryLoading,
  };
};

export default useTotalRevenueByCategoryData;
